import React, { useState } from "react";
import { Text } from "src/components/ui/Text";
import ReportIcon from "../icons/ReportIcon.svg";
import ReportCSVIcon from "../icons/ReportCSVIcon.svg";
import CalendarIcon from "../icons/CalendarIcon.svg";
import moment from "moment";

import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { BaseButton } from "src/components/ui/baseButton";
import { downloadCSVCompanyTHP, downloadDeviceReportCSV } from "src/api/company";
import { useDempStore } from "src/context/stores";
import { cn } from "src/lib/utils";
import { InputFieldWithInnerLabel } from "src/components/ui/inputFields/input-field-with-label";
import { useGetDevice } from "src/api/devices";

const DialogDownloadCSV = ({ onClose }) => {
  const [selectType, setSelectType] = useState("vehicle");
  // const [selectedDay, setSelectedDay] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [errMassage, setErrMassage] = useState(false);
  const { plantId } = useDempStore((state) => state);
  const { deviceList } = useGetDevice(plantId,selectType);
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  // const [selectedDeviceType, setSelectedDeviceType] = useState(null);
  // console.log(deviceList,"deviceList",selectType);

  const listOfDevices = deviceList?.devices?.map(item => ({ label: item.name, value: item.id, device_type: item.device_type })).sort((a, b) => a.label.localeCompare(b.label))
  

  const handleDeviceChange = (e) => {
    const selectedDevice = listOfDevices.find(device => device.value === parseInt(e.target.value));
    
    
    setSelectedDeviceId(selectedDevice?.value);
    // setSelectedDeviceType(selectedDevice?.device_type?.toLowerCase())
    
  };

  

  const formatDate = (date, label=false) => {
    if (date) {
      const { day, month, year } = date;

      const newDate = new Date(`${year}-${month}-${day}`);
      const formatDate = moment(newDate).format(label?" DD MMMM YYYY":"YYYY-MM-DD");

      return formatDate;
    }

    return ``;
  };

  const formatInputValue = (date, label=true) => {
    if (!date) return "Day Month Year";

    return `${formatDate(date, label)}`;
  };

  const onClickDownloadCSV = async () => {
    if (selectedDeviceId && selectedStartDate && selectedEndDate) {
      const startDate = formatDate(selectedStartDate);
      const endDate = formatDate(selectedEndDate);
      const dataRequest = {
        // device_type: selectedDeviceType,
        device_type: selectType === "vehicle" ? "vehicle" : "charger",
        plantId: plantId,
        start_date: startDate, // YYYY MM DD
        end_date: endDate, // YYYY MM DD
      };
      
      // console.log(dataRequest,"dataRequest");
      

      try {
        const { data, error } = await downloadDeviceReportCSV(selectedDeviceId, dataRequest);
        
        if (data) {
          const url = data?.file_url;
          const link = document.createElement("a");
          link.id = url;
          link.href = url;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }


      } catch (error) {
        console.error("Download error:", error);
        alert("Failed to download the report, please try again...");
      }
    } else {
      setErrMassage(true);
    }

   
  };

  

  return (
    <section
      className="absolute top-0 left-0 z-40 flex items-center justify-center w-screen h-screen overflow-hidden bg-black/70"
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      {/* <WidgetLoading text={`Loading ${popupData.name} Truck details`} /> */}

      <div
        className="w-[70%] bg-white rounded-lg max-h-max max-w-[600px] p-4"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="flex flex-col gap-2">
          {/* select type report */}
          <div className="flex flex-col gap-3">
            <div>
              <Text variant="normal-12" className="text-secondary">
                Select report
              </Text>
            </div>
            

            <div className="grid grid-cols-2 gap-8">
              {groupReportType.map((item, index) => {
                return (
                  <div
                    key={`${item?.id}${index}`}
                    className="flex items-center justify-center w-full"
                  >
                    <BtnSelectReport
                      item={item}
                      selectType={selectType}
                      setSelectType={setSelectType}
                    />
                  </div>
                );
              })}
            </div>

            <InputFieldWithInnerLabel
            label="Select Device"
            name="device"
            placeholder="Select Device"
            options={listOfDevices}
            defaultValue={selectedDeviceId}
            optionLabel="select Device"
            type="select"
            onChange={handleDeviceChange}
            
            />

          </div>

          {/* report details */}
          <div className="py-2">
            <div className="flex flex-col gap-2">
              <div>
                <Text variant="normal-12" className="text-secondary">
                  Report details
                </Text>
              </div>

              <div className="inline-flex gap-4">
                {/* TODO: To be updated once more report options are added */}
                <div className="flex items-center gap-2 py-2">
                  <div className="rounded-lg">
                    <img
                      src={ReportCSVIcon}
                      alt="reportCSVIcon"
                      className="w-4 h-5"
                    />
                  </div>

                  <Text variant="semi-12" className="text-vekin-green100">
                    {selectType === 1 ? "Vehicle Report" : "Charger Report"}
                  </Text>
                </div>

                {/* date picker */}
                <div
                  id="dateRangeSelector"
                  className="relative w-[10.625rem] border "
                  onFocus={() => setErrMassage(false)}
                >
                  <DatePicker
                    // value={selectedDay}
                    // formatInputText={formatInputValue}
                    // onChange={setSelectedDay}
                    formatInputText={() => formatInputValue(selectedStartDate)}
                    value={selectedStartDate}
                    onChange={setSelectedStartDate}
                    locale="en"
                    colorPrimary={"#5ABC99"}
                    colorPrimaryLight={"#79C8B040"}
                    inputPlaceholder="Select the date for your report"
                    inputClassName={cn("w-[10.625rem] h-9 !p-2 !pt-3 !pb-0 rounded placeholder-vekin !border-1 !font-semibold text-[10px] !bg-transparent focus:outline-none focus:border-vekin bg-white !text-vekin !text-start cursor-pointer", { 
                      "!border-[#ED1C24]": errMassage === true
                    }
                    )}
                  />
                  <div className="absolute top-1 left-2">
                    <Text variant="normal-10" className="text-secondary">
                      Start date
                    </Text>
                  </div>

                  <div className="absolute rounded-lg top-2 right-2">
                    <img src={CalendarIcon} alt="calendarIcon" />
                  </div>
                </div>

                <div
                  id="dateRangeSelector"
                  className="relative w-[10.625rem] border "
                  onFocus={() => setErrMassage(false)}
                >
                  <DatePicker
                    // value={selectedDay}
                    // formatInputText={formatInputValue}
                    // onChange={setSelectedDay}
                    formatInputText={() => formatInputValue(selectedEndDate)}
                    value={selectedEndDate}
                    onChange={setSelectedEndDate}
                    locale="en"
                    colorPrimary={"#5ABC99"}
                    colorPrimaryLight={"#79C8B040"}
                    inputPlaceholder="Select the date for your report"
                    inputClassName={cn("w-[10.625rem] h-9 !p-2 !pt-3 !pb-0 rounded placeholder-vekin !border-1 !font-semibold text-[10px] !bg-transparent focus:outline-none focus:border-vekin bg-white !text-vekin !text-start cursor-pointer",{
                        "!border-[#ED1C24]": errMassage === true,
                    })}
                  />
                  <div className="absolute top-1 left-2">
                    <Text variant="normal-10" className="text-secondary">
                      End date
                    </Text>
                  </div>

                  <div className="absolute rounded-lg top-2 right-2">
                    <img src={CalendarIcon} alt="calendarIcon" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* download button */}
          <div className="flex flex-row justify-center pt-2 border-t gap-9 border-quartenary ">
            <BaseButton
              variant="secondary"
              size="large"
              className="!min-h-10 !h-10 !min-w-40"
              onClick={onClose}
            >
              <Text variant="semi-12">Cancel</Text>
            </BaseButton>
            <BaseButton
              variant="primary"
              size="large"
              className="!min-h-10 !h-10 !min-w-20"
              onClick={onClickDownloadCSV}
            >
              <Text variant="semi-12">Download Report</Text>
            </BaseButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DialogDownloadCSV;

const groupReportType = [
  { name: "Vehicle Report", id: "vehicle" },
  { name: "Charger Report", id: "charger" },
];

const BtnSelectReport = ({ item, selectType, setSelectType }) => {
  return (
    <button
      className={cn('w-full h-32 flex flex-col justify-center items-center gap-4 rounded-lg border hover:border-vekin-green100',{
        "border-vekin-green100 bg-vekin-green-50 text-vekin-green100 shadow-content-box": item?.id === selectType,
        "border-quartenary bg-transparent text-primary": item?.id !== selectType
      })}
      onClick={(e) => {
        e.stopPropagation();
        setSelectType(item?.id);
      }}
    >
      <div className="rounded-lg">
        <img src={ReportIcon} alt="reportIcon" />
      </div>

      <Text variant="semi-12">{item?.name}</Text>
    </button>
  );
};
